<script setup>
import { ref, onMounted } from 'vue';
import { LocalStorage } from 'shared/helpers/localStorage';
import { LOCAL_STORAGE_KEYS } from 'dashboard/constants/localStorage';
import { setColorTheme } from 'dashboard/helper/themeHelper.js';
import Icon from 'next/icon/Icon.vue';

const currentTheme = ref('light');

const themes = [
  {
    value: 'light',
    icon: 'i-lucide-sun',
    label: 'Clair',
  },
  {
    value: 'dark',
    icon: 'i-lucide-moon',
    label: 'Sombre',
  },
];

// Détecter le thème actuel basé sur le body
const detectCurrentTheme = () => {
  if (document.body.classList.contains('dark')) {
    currentTheme.value = 'dark';
  } else {
    currentTheme.value = 'light';
  }
};

// Charger le thème actuel au montage
onMounted(() => {
  detectCurrentTheme();

  // Observer les changements de classe sur le body
  const observer = new MutationObserver(detectCurrentTheme);
  observer.observe(document.body, {
    attributes: true,
    attributeFilter: ['class'],
  });
});

const setTheme = theme => {
  currentTheme.value = theme;
  LocalStorage.set(LOCAL_STORAGE_KEYS.COLOR_SCHEME, theme);
  const isOSOnDarkMode = window.matchMedia(
    '(prefers-color-scheme: dark)'
  ).matches;
  setColorTheme(isOSOnDarkMode);
};
</script>

<template>
  <div
    class="flex items-center w-full gap-1 p-0.5 rounded-lg bg-n-slate-3 border border-n-slate-5"
  >
    <button
      v-for="theme in themes"
      :key="theme.value"
      class="relative flex items-center justify-center gap-1.5 rounded-md px-3 py-1 text-sm transition-all duration-200 flex-1"
      :class="[
        currentTheme === theme.value
          ? 'bg-white shadow-sm font-semibold'
          : 'text-n-slate-11 hover:text-n-sidebar-text hover:bg-white/50 font-medium',
      ]"
      :style="currentTheme === theme.value ? { color: '#000000' } : {}"
      @click="setTheme(theme.value)"
    >
      <Icon :icon="theme.icon" class="size-4" />
      <span>{{ theme.label }}</span>
    </button>
  </div>
</template>
